
<div class="modal-dialog" style="max-width: 900px;">
  <div class="modal-content">
    <div class="modal-header border-bottom-0">
      <h4 class="modal-title">Select Device</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">
      <table class="table table-sm selectionTable">
        <thead>
          <tr>
            <th>Device Key</th>
            <th>Product Number</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-device [ngForOf]="assignable.candidates">
            <tr class="border-top">
              <td>{{ device.deviceKey }}</td>
              <td>{{ device.productNumber }}</td>
              <td>{{ device.productDescription }}</td>
              <td>
                <button class="btn btn-primary btn-sm float-right" (click)="select(device)">Assign</button>
              </td>
            </tr>
            <tr *ngIf="device.bundledAccessories.length">
              <td></td>
              <td class="text-muted small" colspan="3">Accessories</td>
            </tr>
            <tr *ngFor="let bundledAccessory of device.bundledAccessories">
              <td></td>
              <td>{{bundledAccessory.productNumber}}</td>
              <td>{{bundledAccessory.productDescription}}</td>
            </tr>
            <div class="mb-3"></div>
          </ng-template>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <button class="btn btn-outline-danger btn-sm float-right" (click)="select(null)">Clear</button>
            </td>
          </tr>
        </tfoot>
      </table>
      <form [formGroup]="form">
        <div class="row">
          <div class="col">
            <div class="form-group form-check">
              <input class="form-check-input" type="radio" formControlName="mode" autoLinkToLabel value="self">
              <label class="form-check-label">Only update this asset</label>
            </div>
            <div class="form-group form-check">
              <input class="form-check-input" type="radio" formControlName="mode" autoLinkToLabel value="allEmpty">
              <label class="form-check-label">Update this asset and all eligible unassigned {{ assignable.productNumber }}</label>
            </div>
            <div class="form-group form-check">
              <input class="form-check-input" type="radio" formControlName="mode" autoLinkToLabel value="allSameProductNumber">
              <label class="form-check-label">Update this asset and all other eligible {{ assignable.productNumber }}</label>
            </div>
            <div class="form-group form-check" *ngIf="allowUpdateByDeviceKey">
              <input class="form-check-input" type="radio" formControlName="mode" autoLinkToLabel value="allSameDeviceKey">
              <label class="form-check-label">Update this asset and all other eligible {{ assignable.deviceKey }}</label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>